/**
 * CHARISMA COSMETICS — footer.js v4.0
 * Mobile accordion toggle + Newsletter AJAX + Scroll reveal
 */
(function () {
  'use strict';

  var MOBILE_BP = 700; // px — matches CSS breakpoint

  function ready(fn) {
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);
  }

  /* ── MOBILE ACCORDION ───────────────────────────────── */
  function initAccordion() {
    var toggles = document.querySelectorAll('.cc-footer__col-toggle');
    if (!toggles.length) return;

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.innerWidth > MOBILE_BP) return; // desktop: no-op

        var bodyId = btn.getAttribute('aria-controls');
        var body   = bodyId ? document.getElementById(bodyId) : null;
        if (!body) return;

        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // Close all others
        toggles.forEach(function (otherBtn) {
          if (otherBtn === btn) return;
          otherBtn.setAttribute('aria-expanded', 'false');
          var otherId = otherBtn.getAttribute('aria-controls');
          var otherBody = otherId ? document.getElementById(otherId) : null;
          if (otherBody) otherBody.classList.remove('is-open');
        });

        // Toggle this one
        btn.setAttribute('aria-expanded', String(!isOpen));
        body.classList.toggle('is-open', !isOpen);
      });
    });

    // On resize to desktop, reset all to open-state (CSS handles display)
    window.addEventListener('resize', debounce(function () {
      if (window.innerWidth > MOBILE_BP) {
        toggles.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
          var bodyId = btn.getAttribute('aria-controls');
          var body   = bodyId ? document.getElementById(bodyId) : null;
          if (body) body.classList.remove('is-open');
        });
      }
    }, 200));
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* ── NEWSLETTER ─────────────────────────────────────── */
  function initNewsletter() {
    var form  = document.getElementById('cc-nl-form');
    var input = document.getElementById('cc-nl-email');
    if (!form || !input) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showMsg(form, 'Meherbani karke sahi email likhein.', 'err');
        input.focus(); return;
      }

      var btn  = form.querySelector('.cc-footer__nl-btn');
      var span = btn ? btn.querySelector('span') : null;
      var orig = span ? span.textContent : 'Subscribe';
      setLoad(btn, span, true);

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          form_type: 'customer', utf8: '✓',
          'contact[email]': email, 'contact[tags]': 'newsletter'
        }).toString()
      })
      .then(function (r) {
        if (!r.ok) throw new Error();
        input.value = '';
        showMsg(form, '✓ Shukriya! Aap subscribe ho gaye.', 'ok');
        if (span) span.textContent = '✓ Done';
        if (btn)  btn.style.filter = 'brightness(.82)';
      })
      .catch(function () {
        showMsg(form, 'Kuch masla aaya. Dobara koshish karein.', 'err');
      })
      .finally(function () { setLoad(btn, span, false, orig); });
    });
  }

  function setLoad(btn, span, on, orig) {
    if (!btn) return;
    btn.disabled = on;
    btn.style.opacity = on ? '.6' : '1';
    btn.style.cursor  = on ? 'not-allowed' : 'pointer';
    if (span) span.textContent = on ? '…' : (orig || 'Subscribe');
  }

  function showMsg(form, text, type) {
    var wrap = form.closest('.cc-footer__wrap--nl') || form.parentNode;
    var old  = wrap.querySelector('.cc-footer__nl-msg');
    if (old) old.remove();

    var p = document.createElement('p');
    p.className   = 'cc-footer__nl-msg';
    p.textContent = text;
    p.style.cssText =
      'color:' + (type === 'ok' ? '#f5e8ee' : '#ff80bb') + ';' +
      'opacity:0;transition:opacity .3s;margin-top:10px;font-size:12px;letter-spacing:.4px;';
    form.insertAdjacentElement('afterend', p);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { p.style.opacity = '1'; });
    });
    setTimeout(function () {
      p.style.opacity = '0';
      setTimeout(function () { if (p.parentNode) p.remove(); }, 320);
    }, 5500);
  }

  /* ── SCROLL REVEAL ──────────────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.cc-footer');
    if (!footer) return;

    var els = footer.querySelectorAll(
      '.cc-footer__brand, .cc-footer__col, .cc-footer__nl-strip'
    );
    els.forEach(function (el, i) {
      el.style.opacity   = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition =
        'opacity .6s ease ' + (i * .07) + 's,' +
        'transform .6s ease ' + (i * .07) + 's';
    });

    var ob = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.opacity   = '1';
          en.target.style.transform = 'translateY(0)';
          ob.unobserve(en.target);
        }
      });
    }, { threshold: 0.08 });

    els.forEach(function (el) { ob.observe(el); });
  }

  ready(function () {
    initAccordion();
    initNewsletter();
    initReveal();
  });
}());